import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

export default function PremiumFeatureModal({
  open,
  onClose,
  title = "Premium Feature",
  description = "This feature is locked. Subscribe now to get full access.",
  startFreeTrialLabel = "Start 7 days Free Trial",
  subscribeLabel = "Subscribe Now",
  cancelLabel = "Maybe Later",
  onStartFreeTrial,
  onSubscribe,
  showStartFreeTrial = true,
  showSubscribe = true,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="w-full max-w-2xl rounded-lg bg-white px-6 py-12 text-center shadow-xl sm:px-10">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-red-300 bg-red-50 text-red-500">
            <FontAwesomeIcon icon={faLock} className="h-8 w-8" />
          </div>

          <DialogTitle className="mt-4 text-xl font-medium text-gray-950">
            {title}
          </DialogTitle>

          <p className="mx-auto mt-2 max-w-xl text-sm text-gray-900">
            {description}
          </p>

          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-gray-300 bg-white px-6 py-3 text-sm text-gray-600 transition hover:bg-gray-50 sm:min-w-40"
            >
              {cancelLabel}
            </button>

            {showStartFreeTrial && onStartFreeTrial && (
              <button
                type="button"
                onClick={onStartFreeTrial}
                className="rounded-md border border-red-200 bg-white px-6 py-3 text-sm text-red-500 transition hover:bg-red-50 sm:min-w-40"
              >
                {startFreeTrialLabel}
              </button>
            )}

            {showSubscribe && onSubscribe && (
              <button
                type="button"
                onClick={onSubscribe}
                className="rounded-md bg-red-500 px-6 py-3 text-sm text-white transition hover:bg-red-600 sm:min-w-40"
              >
                {subscribeLabel}
              </button>
            )}
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
